import { NewType } from "#root/ts/NewType.js";

/**
 * A pathname that we pinky promise is relative
 * to the current app.
 */
export class RelativeURL extends NewType<string> {

}

